import React, { Suspense, lazy, useEffect, useRef } from "react";
import LazyLoadComponent from "./LazyLoadComponent";
import "./Main.css";
import "./Drainage_roof.css";

// Ленивые загрузки компонентов
const SoftRoof = lazy(() => import("./soft_roof"));
const ToughRoof = lazy(() => import("./tough_roof"));
const LeakRoof = lazy(() => import("./leak_roof"));
const DrainageRoof = lazy(() => import("./Drainage_roof"));
const AdditionalContainer = lazy(() => import("./additional"));

function Main({
  softRoofRef,
  toughRoof,
  leakRoofRef,
  drainageRef,
  additionalRef,
  onOrderClick,
}) {
  const mainRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0 }
    );

    const containers = mainRef.current.querySelectorAll(".main_container");
    containers.forEach((container) => observer.observe(container));

    return () => observer.disconnect();
  }, []);

  return (
    <main className="main" ref={mainRef}>
      <Suspense fallback={<div>Loading...</div>}>
        <div id="soft-roof" className="main_container" ref={softRoofRef}>
          <img
            alt=""
            src="./img/ruberoid.png"
            className="png-materials png-materials1"
          ></img>
          <img
            alt=""
            src="./img/ruberoid2.png"
            className="png-materials png-materials2"
          ></img>
          <img
            alt=""
            src="./img/ruberoid3.png"
            className="png-materials png-materials5"
          ></img>
          <img
            alt=""
            src="./img/ruberoid4.png"
            className="png-materials png-materials6"
          ></img>
          <LazyLoadComponent animationClass="slide-in-left">
            <SoftRoof onOrderClick={onOrderClick} />
          </LazyLoadComponent>
        </div>
        <div id="tough-roof" className="main_container" ref={toughRoof}>
          <LazyLoadComponent animationClass="slide-in-left">
            <img className="tiles-png" src="./img/tiles.png" alt="Tiles" />
            <ToughRoof onOrderClick={onOrderClick} />
          </LazyLoadComponent>
        </div>
        <div id="leak-roof" className="main_container" ref={leakRoofRef}>
          <svg viewBox="0 0 129 129" className="svg-materials svg-materials1">
            <use href="./img/sprite.svg#level"></use>
          </svg>
          <svg viewBox="0 0 129 129" className="svg-materials svg-materials2">
            <use href="./img/sprite.svg#screwdriver"></use>
          </svg>
          <svg viewBox="0 0 129 129" className="svg-materials svg-materials3">
            <use href="./img/sprite.svg#saw"></use>
          </svg>
          <svg viewBox="0 0 129 129" className="svg-materials svg-materials5">
            <use href="./img/sprite.svg#pliers"></use>
          </svg>
          <svg viewBox="0 0 129 129" className="svg-materials svg-materials6">
            <use href="./img/sprite.svg#hammer"></use>
          </svg>
          <svg viewBox="0 0 129 129" className="svg-materials svg-materials7">
            <use href="./img/sprite.svg#grinder"></use>
          </svg>
          <LazyLoadComponent animationClass="slide-in-left">
            <LeakRoof onOrderClick={onOrderClick} />
          </LazyLoadComponent>
        </div>
        <div id="drainage-roof" className="main_container" ref={drainageRef}>
          <LazyLoadComponent animationClass="slide-in-left">
            <img className="pipe-png" src="./img/pipe.png" alt="Pipe" />
            <DrainageRoof onOrderClick={onOrderClick} />
          </LazyLoadComponent>
        </div>
        <div
          id="additional-services"
          className="main_container"
          ref={additionalRef}
        >
          <svg viewBox="0 0 129 129" className="svg-materials svg-materials1">
            <use href="./img/sprite.svg#level"></use>
          </svg>
          <svg viewBox="0 0 129 129" className="svg-materials svg-materials2">
            <use href="./img/sprite.svg#screwdriver"></use>
          </svg>
          <svg viewBox="0 0 129 129" className="svg-materials svg-materials3">
            <use href="./img/sprite.svg#saw"></use>
          </svg>
          <svg viewBox="0 0 129 129" className="svg-materials svg-materials4">
            <use href="./img/sprite.svg#corner"></use>
          </svg>
          <svg viewBox="0 0 129 129" className="svg-materials svg-materials5">
            <use href="./img/sprite.svg#pliers"></use>
          </svg>
          <svg viewBox="0 0 129 129" className="svg-materials svg-materials6">
            <use href="./img/sprite.svg#hammer"></use>
          </svg>
          <svg viewBox="0 0 129 129" className="svg-materials svg-materials7">
            <use href="./img/sprite.svg#grinder"></use>
          </svg>
          <svg viewBox="0 0 129 129" className="svg-materials svg-materials8">
            <use href="./img/sprite.svg#drill"></use>
          </svg>
          <LazyLoadComponent animationClass="slide-in-left">
            <AdditionalContainer />
          </LazyLoadComponent>
        </div>
      </Suspense>
    </main>
  );
}

export default Main;
